export default __webpack_public_path__ + "static/media/Logo-largo-dorado.5d4cee02.jpg";